export class Variable {
    Name: string;
    Type: string;
    Formula: string;
    Value: string;
}